const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/doc-upload/api-factory');
const serviceFactory = require('../resources/doc-upload/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/rmaccess/${apiConfig.apiversion}/`
    // authToken: config.authToken,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}docupload.uploadInit[{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.init(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}docupload.search[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.search(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}docupload.uploadFinalize[{keys:base64Contracts}][{keys:base64DataObj}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.finalize(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}docupload.uploadChunkFinalize[{keys:base64DataObj}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.finalizeChunk(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
      

    .match(`${p}docupload.getUploadHistory[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.uploadHistory(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}docupload.download[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.download(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))


}

module.exports = addRoutes;
